import { Box } from '@redbubble/design-system';
import styles from './AlsoAvailableOnSectionFooter.module.scss';

export interface AlsoAvailableOnSectionFooterProps {
  children: React.ReactNode;
}

export const AlsoAvailableOnSectionFooter = ({
  children,
}: AlsoAvailableOnSectionFooterProps) => {
  return (
    <Box display="flex" justifyContent="center" className={styles.container}>
      {children}
    </Box>
  );
};
